import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { toHttpParams } from '../project/helpers/to-http-params';
import { LoadResult } from '../types';
import {
  DataTablePagination,
  DataTableSort,
  NotificationState,
  ViewNotificationReceipt,
} from 'studio-components';

const BASE_URL = `${environment.apiOrg.url}/notifications`;

@Injectable()
export class NotificationReceiptService {
  constructor(private http: HttpClient) {}

  load(query: Partial<DataTablePagination | DataTableSort>) {
    return this.http.get<LoadResult<ViewNotificationReceipt>>(BASE_URL, {
      params: toHttpParams({ filter: JSON.stringify(query) }),
    });
  }

  getCount(state: NotificationState | null = null) {
    return this.http.get<{ count: number }>(
      `${BASE_URL}/count`,
      state ? { params: toHttpParams({ state }) } : {},
    );
  }

  markOneReceiptById(receiptId: number, state: NotificationState) {
    return this.http.post<ViewNotificationReceipt>(`${BASE_URL}/mark/${state}/${receiptId}`, {});
  }

  markReceipts(state: NotificationState) {
    return this.http.post<{ count: number }>(`${BASE_URL}/mark/${state}`, {});
  }
}
